/**
 * @generated SignedSource<<0b7fb8e99d0cfc3bb45d9e6c35cd41ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HsSyncUserTokenInput = {
  clientMutationId?: string | null | undefined;
  hubspotutk: string;
  newLeadInfo?: boolean | null | undefined;
  visitorId: string;
};
export type TelemetrySync_HubspotUserToken_Mutation$variables = {
  input: HsSyncUserTokenInput;
};
export type TelemetrySync_HubspotUserToken_Mutation$data = {
  readonly hsSyncUserToken: {
    readonly status: string | null | undefined;
  } | null | undefined;
};
export type TelemetrySync_HubspotUserToken_Mutation = {
  response: TelemetrySync_HubspotUserToken_Mutation$data;
  variables: TelemetrySync_HubspotUserToken_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HsSyncUserTokenPayload",
    "kind": "LinkedField",
    "name": "hsSyncUserToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TelemetrySync_HubspotUserToken_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TelemetrySync_HubspotUserToken_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cb21e4b181f320b1edd85751e89b0998",
    "id": null,
    "metadata": {},
    "name": "TelemetrySync_HubspotUserToken_Mutation",
    "operationKind": "mutation",
    "text": "mutation TelemetrySync_HubspotUserToken_Mutation(\n  $input: HsSyncUserTokenInput!\n) {\n  hsSyncUserToken(input: $input) {\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6752c9dc6413bea631e31e782d7b8dd";

export default node;
